import { TypographyH2, TypographyP } from '@talentmesh/ui/components/typography';
import { useInvitationPageContext } from '../Contexts/InvitationPageContext';
import BackButton from './BackButton';
import UIStrings from '@/Utils/UIStrings';

const Header = () => {
    const { recruitmentName } = useInvitationPageContext();
    return (
        <div className="flex flex-col items-start gap-2.5">
            <BackButton />
            <div className="flex flex-col gap-1">
                <TypographyH2>{`${UIStrings.AttractApplicants} ${UIStrings.For} ${recruitmentName}`}</TypographyH2>
                <TypographyP>{UIStrings.EasilyAttractTopApplicantsThrough}</TypographyP>
            </div>
        </div>
    );
};
export default Header;
